import { render } from "./force-challenge.vue?vue&type=template&id=3a063b27"
import script from "./force-challenge.vue?vue&type=script&lang=js"
export * from "./force-challenge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__